import { publicClient } from '../../api/client';
import type { components } from '../../api/schema';

type SMSConsentUpdate = components['schemas']['SMSConsentUpdate'];

export async function updateSMSConsent(data: SMSConsentUpdate) {
  // Public endpoint - no auth needed.
  const { data: result, error } = await publicClient.PUT('/consent/sms', {
    body: data,
  });
  if (error) throw new Error(`Failed to update SMS consent: ${JSON.stringify(error)}`);
  return result;
}
